/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTransferVertical = createReactComponent(
  "transfer-vertical",
  "IconTransferVertical",
  [
    ["path", { d: "M10 4v16l-6 -5.5", key: "svg-0" }],
    ["path", { d: "M14 20v-16l6 5.5", key: "svg-1" }]
  ]
);

export { IconTransferVertical as default };
//# sourceMappingURL=IconTransferVertical.js.map
